import {
  isNavGroup,
  isNavSection,
  NavGroup,
  NavLeaf,
  NavNode,
  NavSection,
} from "./navigation.types"

export interface AccessRules {
  isAdmin: boolean
  accessibleLabels: string[] | null
}

const ALL_ACCESS = "all"

const isAllowed = (node: NavLeaf | NavGroup, accessibleLabels: string[]): boolean =>
  accessibleLabels.includes(node.label)

const filterSectionChildren = (
  section: NavSection,
  accessibleLabels: string[]
): NavSection | null => {
  const children = section.children.filter((child) => isAllowed(child, accessibleLabels))
  if (children.length === 0) return null
  return { ...section, children }
}

export function filterByAccess(nodes: NavNode[], rules: AccessRules): NavNode[] {
  if (rules.isAdmin) return nodes

  const labels = rules.accessibleLabels ?? []
  if (labels.includes(ALL_ACCESS)) return nodes

  const result: NavNode[] = []
  for (const node of nodes) {
    if (isNavSection(node)) {
      const filtered = filterSectionChildren(node, labels)
      if (filtered) result.push(filtered)
      continue
    }

    if (isNavGroup(node)) {
      if (isAllowed(node, labels)) result.push(node)
      continue
    }

    if (isAllowed(node, labels)) result.push(node)
  }
  return result
}
